import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'hdi-top-bar-loader',
  standalone: true,
  imports: [CommonModule, NgxSkeletonLoaderModule],
  templateUrl: './top-bar-loader.component.html',
  styleUrls: ['../top-bar.component.scss'],
})
export class TopBarLoaderComponent {}
